import { render, staticRenderFns } from "./CommunityPortal.vue?vue&type=template&id=89915472&"
import script from "./CommunityPortal.vue?vue&type=script&lang=js&"
export * from "./CommunityPortal.vue?vue&type=script&lang=js&"
import style0 from "./CommunityPortal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports